import React, { useCallback, useEffect, useState } from "react";
import Body from "src/components/common/Body";
import BottomModal, { RefProps } from "src/components/common/BottomModal";
import Button from "src/components/common/Button";
import List from "src/components/common/List";
import Chip from "src/components/common/Chip";
import SVG from "src/utils/SVG";
import styled from "styled-components";
import cn from "classnames";
import SearchInput from "src/components/common/SearchInput";
import RecentKeyword from "src/components/as/RecentKeyword";
import SearchSortItem from "src/components/filter/SearchSortItem";
import AsListItem from "src/components/as/AsListItem";
import { useAsListQuery } from "src/api/asAPI";
import { useAppSelector } from "src/store/actions/action";
import BottomFixed from "src/components/common/BottomFixed";
import IconButton from "src/components/common/IconButton";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { setRecentKeyword } from "src/store/reducers/asReduce";
import { shallowEqual, useDispatch } from "react-redux";
import SearchFilterItemCommon from "src/components/filter/SearchStoreFilterItem";
import setQueryStringVer from "src/utils/reuseQueryString";
import { cloneDeep, isEmpty, replace } from "lodash";
import AlarmButton from "src/components/common/AlarmButton";
import id from "date-fns/esm/locale/id/index.js";
import { BLOCKED_USER, SOS_AS_LIST } from "../../utils/sosFunc";

const globalBrand = {
  title: "브랜드",
  chip: ["MLB", "MLB KIDS", "Discovery", "DUVETICA", "SUPRA", "Sergio Tacchini"],
  check: [false, false, false, false, false, false],
};
// 초기 값 세팅
const globalAsType = {
  title: "A/S 유형",
  chip: ["마감재", "집기", "마네킨", "영상", "간판/로고", "설비/누수/소방", "전기/조명", "음향", "소도구", "기타"],
  check: [false, false, false, false, false, false, false, false, false, false],
};
const globalStoreType = {
  title: "매장 유형",
  chip: ["백화점", "대리점", "직영점", "면세점"],
  check: [false, false, false, false],
};
const globalDateType = {
  title: "기간",
  chip: ["1개월", "3개월", "6개월", "12개월", "기간선택"],
  check: [false, false, false, false, false],
};

const globalAsStateType = {
  title: "상태별",
  chip: ["접수중", "업체배정", "견적진행", "A/S진행", "완료", "취소"],
  check: [false, false, false, false, false, false],
};

const AsList = () => {
  // 퍼블에서 사용하는 변수
  const filterModalRef = React.useRef<RefProps>(null);
  const filterStateModalRef = React.useRef<RefProps>(null);
  const filterBoxRef = React.useRef<HTMLDivElement>(null);
  const sortModalRef = React.useRef<RefProps>(null);

  // 필터모달
  const openFilterModal = useCallback(() => {
    if (filterModalRef.current) filterModalRef.current.modalOpen();
    setRerender(false);
  }, []);

  const openStateFilterModal = useCallback(() => {
    if (filterStateModalRef.current) filterStateModalRef.current.modalOpen();
    setRerender(false);
  }, []);

  // 정렬모달
  const openSortModal = useCallback(() => {
    if (sortModalRef.current) sortModalRef.current.modalOpen();
  }, []);

  // ========================== 퍼블리싱 영역 끝 ==========================

  // 라이브러리 선언 영역
  const navigate = useNavigate();
  const navigateState = useLocation();
  const dispatch = useDispatch();

  // 글로벌 초기 값 영역
  const userInfo = useAppSelector((state) => state.userReduce.userInfo, shallowEqual);
  const reduceRecentContents = useAppSelector((state) => state.asReduce.searchContentsData);

  const reduceSearchStartDate = useAppSelector((state) => state.asReduce.searchStartDate);
  const reduceSearchEndDate = useAppSelector((state) => state.asReduce.searchEndDate);

  // 뒤로가기에서 필터를 유지하기 위한 sessionStorage
  const sessionStoragePage = window.sessionStorage.getItem("page");
  const sessionStorageAfter = window.sessionStorage.getItem("after");
  const sessionStorageInit = window.sessionStorage.getItem("init");

  // const sessionStorageAfterAsState = window.sessionStorage.getItem("afterAsState");
  // const sessionStorageAsState = window.sessionStorage.getItem("asState");
  const sessionStorageContents = window.sessionStorage.getItem("contents");

  const sessionStorageSort = window.sessionStorage.getItem("sortName");
  const sessionStorageSortIdx = window.sessionStorage.getItem("sortIdx");

  const sessionNewStore = window.sessionStorage.getItem("newStore");

  // ================================================================================================
  // state 초기 상태값 영역
  // ================================================================================================

  // 검색 값 초기화
  const [rerender, setRerender] = useState(false);

  const [api, setApi] = useState({
    apiSkip: true,
    filterData: "",
  });

  const getBrand = (array: boolean[]) => {
    const index = array.indexOf(true);
    switch (index) {
      case 0:
        return "MLB";
      case 1:
        return "MLB KIDS";
      case 2:
        return "Discovery";
      case 3:
        return "DUVETICA";
      case 4:
        return "SUPRA";
      case 5:
        return "Sergio Tacchini";
      default:
        return "MLB";
    }
  };

  const { apiSkip, filterData } = api;
  // 필터 검색
  const [init, setInit] = useState({
    brandType: { ...globalBrand },
    asType: { ...globalAsType },
    storeType: { ...globalStoreType },
    dateType: { ...globalDateType },
    asStateType: { ...globalAsStateType },
    selectedChips: [],
  });

  const { brandType, asType, storeType, dateType, asStateType, selectedChips } = init;

  const [after, setAfter] = useState({
    afterBrandType: { ...globalBrand },
    afterAsType: { ...globalAsType },
    afterStoreType: { ...globalStoreType },
    afterDateType: { ...globalDateType },
    afterAsStateType: { ...globalAsStateType },
    afterSelectedChips: [],
  });

  const { afterBrandType, afterAsType, afterStoreType, afterDateType, afterAsStateType, afterSelectedChips } = after;

  // 상태 검색
  // const [asState, setAsState] = useState({
  //   asStateType: { ...globalAsStateType },
  //   asStateSelectedChips: [],
  // });

  // const { asStateType, asStateSelectedChips } = asState;

  // const [afterAsState, setAfterAsState] = useState({
  //   afterAsStateType: { ...globalAsStateType },
  //   afterAsStateSelectedChips: [],
  // });

  // const { afterAsStateType, afterAsStateSelectedChips } = afterAsState;

  const [hasAlarm, setHasAlarm] = useState(false);

  // 최근 검색어 state
  const [as, setAs] = useState<any>({
    register: false,
    asStop: false,
    currentSearchStorage: [],
  });
  const { register, asStop, currentSearchStorage } = as;

  const [queryString, setQueryString] = useState<any>({
    typeSearchArray: [],
    processSearchArray: [],
    contentsSearchString: "",
    asSortSearchString: "최신순",
    pageSearchNumber: 0,
    newStoreSearchString: "",
  });

  const [page, setPage] = useState<number | any>();

  const [currentPage, setCurrentPage] = useState<number | any>();

  const [recentContents, setRecentContents] = useState<string>();

  const [newStoreToggle, setNewStoreToggle] = useState<boolean>(false);

  const [searchStartDate, setSearchStartDate] = useState<string>("");
  const [searchEndDate, setSearchEndDate] = useState<string>("");

  // 정렬 선택시
  const [sortIdx, setSordIdx] = useState<number>(0);
  const [sortName, setSortName] = useState<string>("최신순");

  const [initVisible, setInitVisible] = useState<boolean>(false);

  // 세션으로 api 호출시
  const [sessionAPICall, setSessionAPICall] = useState<boolean>(false);

  // ================================================================================================
  // API 영역
  // ================================================================================================

  const asList = useAsListQuery(filterData, { skip: apiSkip });

  // ================================================================================================
  // 생명주기 영역 (hook영역)
  // ================================================================================================

  const preventClose = (e: BeforeUnloadEvent) => {
    // e.preventDefault();
    // e.returnValue = ""; //Chrome에서 동작하도록
    // 새로고침 이슈
    window.sessionStorage.clear();
    // history.replaceState({state :""}, {pathname:"/as-list"});
  };

  useEffect(() => {
    // 새로고침 할 때
    (() => {
      window.addEventListener("beforeunload", preventClose);
    })();
    return () => {
      const path = location.pathname;
      // as-list에서만 새로고침해야 필터가 삭제 되도록 함
      if (path.indexOf("as-list") < 0) {
        window.sessionStorage.setItem("page", currentPage);
        // as 필터 값
        window.sessionStorage.setItem("after", JSON.stringify(after));
        window.sessionStorage.setItem("init", JSON.stringify(init));
        // // 상태 필터 값
        // window.sessionStorage.setItem("afterAsState", JSON.stringify(afterAsState));
        // window.sessionStorage.setItem("asState", JSON.stringify(asState));
        // 검색어 필터 값
        window.sessionStorage.setItem("contents", recentContents!);
        // 정렬 필터
        window.sessionStorage.setItem("sortName", String(sortName));
        window.sessionStorage.setItem("sortIdx", String(sortIdx));
        if (newStoreToggle) {
          window.sessionStorage.setItem("newStore", "T");
        } else {
          window.sessionStorage.setItem("newStore", "");
        }
      }
    };
  });

  // 현재 페이지 세팅
  useEffect(() => {
    if (asList.isSuccess) {
      setCurrentPage(asList.data.data.meta.currentPage);
    }
  }, [asList]);

  // 최근검색어를 선택 했을때
  useEffect(() => {
    if (!isEmpty(reduceRecentContents)) {
      setCurrentPage(1);
      setRecentContents(reduceRecentContents!);
      setQueryString({
        ...queryString,
        pageSearchNumber: 1,
        contentsSearchString: reduceRecentContents,
      });
      dispatch(setRecentKeyword(""));
    }
  }, [reduceRecentContents]);

  // 본사 홈에서 진행중 A/S 박스를 눌러서 들어왔을때 세팅 값
  useEffect(() => {
    setSessionAPICall(true);
    setCurrentPage(1);
    if (!isEmpty(navigateState.state)) {
      const state: any = navigateState.state;
      const process: any = state.process;
      const checkArray: any = state.checkArray;

      setAfter({
        ...after,
        afterAsStateType: {
          title: "상태별",
          chip: ["접수중", "업체배정", "견적진행", "A/S진행", "완료", "취소"],
          check: checkArray,
        },
        afterBrandType: {
          title: "브랜드",
          chip: ["MLB", "MLB KIDS", "Discovery", "DUVETICA", "SUPRA", "Sergio Tacchini"],
          check: state.brand,
        },
        afterSelectedChips: afterSelectedChips.concat(process),
      });

      setInit({
        ...init,
        asStateType: {
          title: "상태별",
          chip: ["접수중", "업체배정", "견적진행", "A/S진행", "완료", "취소"],
          check: checkArray,
        },
        brandType: {
          title: "브랜드",
          chip: ["MLB", "MLB KIDS", "Discovery", "DUVETICA", "SUPRA", "Sergio Tacchini"],
          check: state.brand,
        },
        selectedChips: selectedChips.concat(process),
      });
    } else {
      let afterSelectedChipsLength = 0;
      if (!isEmpty(sessionStorageAfter) && typeof sessionStorageAfter !== undefined) {
        const jsonParser = JSON.parse(sessionStorageAfter!);
        afterSelectedChipsLength = jsonParser.afterSelectedChips.length;
      }
      // page, sort는 기본이 1, 최신순이기때문에
      if (
        (!isEmpty(sessionStoragePage) && typeof sessionStoragePage !== undefined && sessionStoragePage !== "1") ||
        afterSelectedChipsLength > 0 ||
        (!isEmpty(sessionStorageSort) && typeof sessionStorageSort !== undefined && sessionStorageSort !== "최신순") ||
        (!isEmpty(sessionStorageContents) && typeof sessionStorageContents !== undefined && sessionStorageContents !== "undefined") ||
        (!isEmpty(sessionNewStore) && typeof sessionNewStore !== undefined && sessionNewStore !== "undefined")
      ) {
        let tempPage: any = 1;
        let tempAfter: any = [];
        // let tempAfterAsState: any = [];
        let tempContents: any = "";
        let tempSortName: any = "";
        let tempNewStore: any = "";
        if (!isEmpty(sessionStoragePage) && typeof sessionStoragePage !== undefined) {
          tempPage = sessionStoragePage;
          setCurrentPage(sessionStoragePage);
        }
        if (!isEmpty(sessionStorageAfter) && typeof sessionStorageAfter !== undefined) {
          const jsonParser = JSON.parse(sessionStorageAfter!);
          tempAfter = jsonParser.afterSelectedChips;
          setAfter(jsonParser);
        }
        // if (!isEmpty(sessionStorageAfterAsState) && typeof sessionStorageAfterAsState !== undefined) {
        //   const stateJsonParser = JSON.parse(sessionStorageAfterAsState!);
        //   tempAfterAsState = stateJsonParser.afterAsStateSelectedChips;
        //   setAfterAsState(stateJsonParser);
        // }
        if (!isEmpty(sessionStorageSort) && typeof sessionStorageSort !== undefined) {
          tempSortName = sessionStorageSort;
          setSortName(sessionStorageSort!);
          setSordIdx(Number(sessionStorageSortIdx));
        }
        if (!isEmpty(sessionStorageContents) && typeof sessionStorageContents !== undefined && sessionStorageContents !== "undefined") {
          tempContents = sessionStorageContents;
          setRecentContents(tempContents);
        }
        if (!isEmpty(sessionNewStore) && typeof sessionNewStore !== undefined && sessionNewStore !== "undefined") {
          tempNewStore = sessionNewStore;
          setNewStoreToggle(true);
        }
        setQueryString({
          ...queryString,
          pageSearchNumber: Number(tempPage),
          typeSearchArray: tempAfter,
          // processSearchArray: tempAfterAsState,
          contentsSearchString: tempContents,
          asSortSearchString: tempSortName,
          newStoreSearchString: tempNewStore,
        });

        if (!isEmpty(sessionStorageInit) && typeof sessionStorageInit !== undefined) {
          const jsonParser = JSON.parse(sessionStorageInit!);
          setInit(jsonParser);
        }
        // if (!isEmpty(sessionStorageAsState) && typeof sessionStorageAsState !== undefined) {
        //   const jsonParser = JSON.parse(sessionStorageAsState!);
        //   setAsState(jsonParser);
        // }
      }
    }
    const sessionTime = setTimeout(() => {
      window.sessionStorage.removeItem("page");
      window.sessionStorage.removeItem("after");
      window.sessionStorage.removeItem("init");
      window.sessionStorage.removeItem("contents");
      window.sessionStorage.removeItem("sortName");
      window.sessionStorage.removeItem("sortIdx");
      window.sessionStorage.removeItem("newStore");
    }, 300);

    return () => clearTimeout(sessionTime);
  }, []);

  // 쿼리 실행 영역
  // 쿼리가 2번 실행 되어서 sessionAPICall을 추가 함

  useEffect(() => {
    if (queryString) {
      if (sessionAPICall) {
        const searchFilter = setQueryStringVer(queryString, searchStartDate, searchEndDate, "as");
        setApi({
          ...api,
          filterData: searchFilter,
          apiSkip: false,
        });
      }
    }
  }, [queryString, sessionAPICall]);

  // 쿼리 실행 됨
  // 필터에 값이 추가가 되면 실행
  useEffect(() => {
    if (!sessionStoragePage && !sessionStorageAfter && !sessionStorageContents && !sessionStorageSort && !sessionNewStore) {
      if (afterSelectedChips.length > 0) {
        setQueryString({
          ...queryString,
          typeSearchArray: afterSelectedChips,
          pageSearchNumber: 1,
        });
        setCurrentPage(1);
      }
    } else if (!isEmpty(navigateState.state)) {
      // home에서 상태 박스를 클릭해서 넘어올때 필터를 추가하기 위한 로직
      const state: any = navigateState.state;
      const process: any = state.process;
      if (process) {
        if (afterSelectedChips.length > 0) {
          setQueryString({
            ...queryString,
            typeSearchArray: afterSelectedChips,
            pageSearchNumber: 1,
          });
          setCurrentPage(1);
        }
      }
    }
  }, [afterSelectedChips]);

  useEffect(() => {
    if (userInfo.user_type === "E") {
      setAs({
        ...as,
        register: false,
        asStop: true,
      });
    } else if (userInfo.user_type === "S") {
      setAs({
        ...as,
        register: true,
      });
    } else if (userInfo.user_type === "M") {
      setAs({
        ...as,
        register: false,
      });
    }
  }, [register]);

  // 날짜 기간 검색을 위한 리듀서
  useEffect(() => {
    setSearchStartDate(reduceSearchStartDate!);
    setSearchEndDate(reduceSearchEndDate!);
  }, [reduceSearchStartDate, reduceSearchEndDate]);

  // 필터 선택시 상단 스크롤 끝으로 이동
  const [filterSelected, setFilterSelected] = useState(false);
  useEffect(() => {
    if (filterBoxRef.current && filterSelected) {
      const scrollX = filterBoxRef.current.scrollLeft;
      const scrollXWidth = filterBoxRef.current.scrollWidth;
      filterBoxRef.current.scrollTo({ top: 0, left: scrollX + scrollXWidth, behavior: "smooth" });
      setFilterSelected(false);
    }
    setFilterSelected(true);
  }, [afterSelectedChips]);

  // ================================================================================================
  // click 이벤트 영역
  // ================================================================================================

  // 페이지네이션에 보내줘야할 함수 정의
  const setPageFunc = (currentPage: number) => {
    setQueryString({
      ...queryString,
      pageSearchNumber: currentPage,
    });
    setPage(currentPage);
    setCurrentPage(currentPage);
  };

  const childrenSortIdxFunc = (idx: number) => {
    setSordIdx(idx);
  };

  // SearchStoreFilterItem에 보내어 필터 값을 받아오는 함수
  const setInitFunc = (propsSelectedFliterCheck: boolean) => {
    setInitVisible(propsSelectedFliterCheck);
  };

  // ================================================================================================
  // ============================= 필터 검색에 대한 클릭이벤트 시작  ================================
  // ================================================================================================
  const initBtn = () => {
    // setQueryString({
    //   ...queryString,
    //   typeSearchArray: [],
    //   // contentsSearchString: "",
    //   // asSortSearchString: "최신순",
    //   pageSearchNumber: 1,
    // });
    setInit((prev) => ({
      ...prev,
      brandType: { ...globalBrand },
      asType: { ...globalAsType },
      storeType: { ...globalStoreType },
      dateType: { ...globalDateType },
      asStateType: { ...globalAsStateType },
      selectedChips: [],
    }));
  };

  // 적용하기
  // ...(spead)는 얕은 복사는 객체의 1depth까지 복사
  // cloneDeep 깊은 복사는 객체 전부를 복사하여, 같은 객체를 공유하지 않는다.
  const confirmBtn = () => {
    setAfter({
      ...after,
      afterBrandType: cloneDeep(brandType),
      afterAsType: cloneDeep(asType),
      afterStoreType: cloneDeep(storeType),
      afterDateType: cloneDeep(dateType),
      afterAsStateType: cloneDeep(asStateType),
      afterSelectedChips: [...selectedChips],
    });
    if (selectedChips.length < 1) {
      setQueryString({
        ...queryString,
        typeSearchArray: [],
        pageSearchNumber: 1,
      });
    }

    setCurrentPage(1);

    if (filterModalRef.current) filterModalRef.current.modalClose();
  };

  const closeBtn = () => {
    setInit({
      ...init,
      brandType: cloneDeep(afterBrandType),
      asType: cloneDeep(afterAsType),
      storeType: cloneDeep(afterStoreType),
      dateType: cloneDeep(afterDateType),
      asStateType: cloneDeep(afterAsStateType),
      selectedChips: [...afterSelectedChips],
    });
  };

  // AS 상태 전체 필터 클릭 이벤트

  // const asStateInitBtn = () => {
  //   setQueryString({
  //     ...queryString,
  //     processSearchArray: [],
  //     pageSearchNumber: 1,
  //   });
  //   setAsState((prev) => ({
  //     ...prev,
  //     asStateType: { ...globalAsStateType },
  //     asStateSelectedChips: [],
  //   }));
  // };

  // const asStateConfirmBtn = () => {
  //   setAfterAsState({
  //     ...afterAsState,
  //     afterAsStateType: { ...asStateType },
  //     afterAsStateSelectedChips: [...asStateSelectedChips],
  //   });

  //   setCurrentPage(1);

  //   if (filterStateModalRef.current) filterStateModalRef.current.modalClose();
  // };

  // const asStateCloseBtn = () => {
  //   setAsState({
  //     ...asState,
  //     asStateType: { ...afterAsStateType },
  //     asStateSelectedChips: [...afterAsStateSelectedChips],
  //   });
  // };
  // ================================================================================================
  // ============================= 필터 검색에 대한 클릭이벤트 끝 ================================
  // ================================================================================================

  // 정렬 클릭 이벤트
  const sortBtn = (e: any) => {
    const sortName = e.target.textContent;
    setSortName(sortName);
    // setCurrentPage(1);
    setQueryString({
      ...queryString,
      // pageSearchNumber: 1,
      asSortSearchString: sortName,
    });
    if (sortModalRef.current) sortModalRef.current.modalClose();
  };

  // 검색어 이벤트
  const searchContents = (e: any) => {
    const contents = e.currentTarget.parentElement?.childNodes[0].value;
    setCurrentPage(1);
    setRecentContents(contents);
    setQueryString({
      ...queryString,
      pageSearchNumber: 1,
      contentsSearchString: contents,
    });
    const currentSearch: any = window.localStorage.getItem("currentSearch");

    let JsonData: Array<string> = [];
    if (currentSearch) {
      JsonData = JSON.parse(currentSearch);
    }

    for (let i = 0; i < JsonData.length; i++) {
      if (JsonData[i] === contents) {
        return;
      }
    }
    if (contents) {
      if (JsonData.length < 4) {
        JsonData.push(contents);
        window.localStorage.setItem("currentSearch", JSON.stringify(JsonData));
      } else {
        JsonData.splice(0, 1);
        JsonData.push(contents);
        window.localStorage.setItem("currentSearch", JSON.stringify(JsonData));
      }
    }
  };

  // asList에서 선택된 필터 X누를때 이벤트
  const deleteSelectChips = (value: string, idx: number) => {
    // 자식영역(props)의 선택된 검색어 삭제
    const deleteSelect = selectedChips.filter((value: any, selectIdx: number) => selectIdx !== idx);

    brandType.chip.map((asSelectValue: any, selectIdx: number) => {
      if (asSelectValue === value) {
        brandType.check[selectIdx] = false;
      }
    });

    asType.chip.map((asSelectValue: any, selectIdx: number) => {
      if (asSelectValue === value) {
        asType.check[selectIdx] = false;
      }
    });

    storeType.chip.map((selectValue: any, selectIdx: number) => {
      if (selectValue === value) {
        storeType.check[selectIdx] = false;
      }
    });

    dateType.chip.map((dateValue: any, selectIdx: number) => {
      if (dateValue === value) {
        dateType.check[selectIdx] = false;
      }
    });

    asStateType.chip.map((asSelectValue: any, selectIdx: number) => {
      if (asSelectValue === value) {
        asStateType.check[selectIdx] = false;
      }
    });

    setInit({
      ...init,
      selectedChips: deleteSelect,
    });

    setQueryString({
      ...queryString,
      typeSearchArray: deleteSelect,
    });

    // 부모영역(현재)의 선택된 검색어 삭제
    const deleteAfterSelect = afterSelectedChips.filter((value: any, selectIdx: number) => selectIdx !== idx);
    setAfter({
      ...after,
      afterSelectedChips: deleteAfterSelect,
    });
    if (!isEmpty(navigateState.state)) {
      console.log(asStateType);
      const tempt: any = navigateState.state;
      navigate(location.pathname, { state: { ...tempt, process: deleteAfterSelect, checkArray: asStateType.check, brand: brandType.check } }); // home에서 넘어온 state 값을 clear
    }
  };

  // AS 상태 전체 필터에서  asList에서 선택된 필터 X누를때 이벤트
  // const asStateDeleteSelectChips = (value: string, idx: number) => {
  //   // 자식영역(props)의 선택된 검색어 삭제
  //   const deleteSelect = asStateSelectedChips.filter((value: any, selectIdx: number) => selectIdx !== idx);

  //   asStateType.chip.map((asSelectValue: any, selectIdx: number) => {
  //     if (asSelectValue === value) {
  //       asStateType.check[selectIdx] = false;
  //     }
  //   });

  //   setAsState({
  //     ...asState,
  //     asStateSelectedChips: deleteSelect,
  //   });

  //   setQueryString({
  //     ...queryString,
  //     processSearchArray: deleteSelect,
  //   });

  //   // 부모영역(현재)의 선택된 검색어 삭제
  //   const deleteAfterSelect = afterAsStateSelectedChips.filter((value: any, selectIdx: number) => selectIdx !== idx);
  //   setAfterAsState({
  //     ...afterAsState,
  //     afterAsStateSelectedChips: deleteAfterSelect,
  //   });
  // };

  const newStoreBtn = () => {
    if (newStoreToggle) {
      setQueryString({ ...queryString, newStoreSearchString: "", pageSearchNumber: 1 });
    } else {
      setQueryString({ ...queryString, newStoreSearchString: "T", pageSearchNumber: 1 });
    }
    setCurrentPage(1);
    setNewStoreToggle(!newStoreToggle);
  };

  // 최근 검색어 삭제
  const recentKeywordOneDelete = (e: any) => {
    currentSearchStorage.splice(e, 1);
  };

  // 최근 검색어 모두 삭제
  const recentKeywordAllDelete = () => {
    setAs({
      ...as,
      currentSearchStorage: [],
    });
  };

  const onKeyPress = (e: any) => {
    if (e.key === "Enter") {
      searchContents(e);
    }
  };

  const goAsDetail = (asIdx: string) => {
    // 뒤로가기에서 필터를 유지하기 위한 sessionStorage
    // window.sessionStorage.setItem("page", currentPage);
    // // as 필터 값
    // window.sessionStorage.setItem("after", JSON.stringify(after));
    // window.sessionStorage.setItem("init", JSON.stringify(init));
    // // // 상태 필터 값
    // // window.sessionStorage.setItem("afterAsState", JSON.stringify(afterAsState));
    // // window.sessionStorage.setItem("asState", JSON.stringify(asState));
    // // 검색어 필터 값
    // window.sessionStorage.setItem("contents", recentContents!);
    // // 정렬 필터
    // window.sessionStorage.setItem("sortName", String(sortName));
    // window.sessionStorage.setItem("sortIdx", String(sortIdx));

    navigate("/as-detail/" + asIdx);
  };

  const deleteSearchContents = () => {
    if (recentContents) {
      setCurrentPage(1);
      setRecentContents("");
      setQueryString({
        ...queryString,
        pageSearchNumber: 1,
        contentsSearchString: "",
      });
    }
  };

  ////////SOS
  const [ugcList, setUgcList] = useState<any>({ data: { data: { data: [] } } });

  useEffect(() => {
    if (userInfo.user_id == "m1" && asList?.data?.data) {
      if (window.localStorage.getItem(SOS_AS_LIST) || window.localStorage.getItem(BLOCKED_USER)) {
        const banNoticeList: { list: string[] | undefined } | undefined = JSON.parse(window.localStorage.getItem(SOS_AS_LIST) || "{}");
        const banUserList: { list: string[] | undefined } | undefined = JSON.parse(window.localStorage.getItem(BLOCKED_USER) || "{}");
        const tempData = asList.data.data.data;
        const result = tempData
          .filter((res: any) => {
            if (!banNoticeList?.list?.includes(res.as_idx)) return res;
          })
          .filter((res: any) => {
            if (!banUserList?.list?.includes(res.store_id)) return res;
          });

        const cloneData = cloneDeep(asList);
        cloneData.data.data.data = result;

        setUgcList(cloneData);
      }
    }
  }, [asList]);

  return (
    <>
      <header className={cn({ hasAlarm: hasAlarm })}>
        <div>
          <Button variant="text" className="btn-back no-ico">
            A/S
          </Button>
        </div>
        <div className="btn-box">
          <AlarmButton />
          <IconButton btnName="마이페이지" className="user" onClick={() => navigate("/profile/" + userInfo.user_id)}>
            <SVG name="userBlack" />
          </IconButton>
        </div>
      </header>

      <Body isTabbar={true}>
        <SearchSet>
          <SearchInput
            type="text"
            id="search-input"
            placeholder="검색어를 입력해주세요."
            defaultValue={recentContents}
            onClick={(e) => searchContents(e)}
            onKeyPress={(e) => onKeyPress(e)}
            deleteSearchContentFunc={deleteSearchContents}
          />
        </SearchSet>

        <RecentKeyword onClick={(e: any) => recentKeywordOneDelete(e)} onClick2={() => recentKeywordAllDelete()} />

        <FilterBtnSet ref={filterBoxRef}>
          <Button variant="contained" br="round" color="secondary" size="medium" onClick={openFilterModal}>
            <SVG name="filter" width={16} height={16} viewBox="0 0 16 16" />
            필터
          </Button>
          <Button variant="contained" br="round" color="secondary" size="medium" onClick={openSortModal}>
            <SVG name="sort" width={14.637} height={16.348} viewBox="0 0 14.637 16.348" />
            {sortName}
          </Button>
          {userInfo.user_type !== "S" && (
            <Button className="only-new" variant="contained" br="round" color={newStoreToggle ? "active" : "secondary"} size="medium" onClick={newStoreBtn}>
              {newStoreToggle ? (
                <SVG name="toggleActive" width={16} height={16} viewBox="0 0 16 16" />
              ) : (
                <SVG name="toggle" width={16} height={16} viewBox="0 0 16 16" />
              )}
              신규매장만
            </Button>
          )}
          {afterSelectedChips?.map((v, idx) => {
            return (
              <Chip variant="contained" deleted={true} key={idx} onDelete={() => deleteSelectChips(v, idx)}>
                {v}
              </Chip>
            );
          })}
        </FilterBtnSet>

        <List pd="0 15px">
          {asList.isSuccess ? (
            <AsListItem
              data={userInfo.user_id == "m1" && ugcList.data.data.meta ? ugcList.data : asList.data}
              asDetailClick={(idx: string) => goAsDetail(idx)}
              onClick={(p: any) => setPageFunc(p)}
              currentPage={currentPage}
            />
          ) : (
            ""
          )}
        </List>

        {register ? (
          <BottomFixed>
            <Link to={"/as-register"}>
              <IconButton btnName="글등록하기">
                <SVG name="write" width={53} height={53} viewBox="0 0 53 53" />
              </IconButton>
            </Link>
          </BottomFixed>
        ) : (
          ""
        )}
      </Body>

      <BottomModal
        ref={filterModalRef}
        onClick={() => initBtn()}
        onClick2={() => confirmBtn()}
        onClick3={() => closeBtn()}
        modalTitle="검색 필터"
        headerBtn="초기화"
        footerBtn="적용"
        dimClickFun={closeBtn}
        initVisible={initVisible}
      >
        <List pd="0 15px" itemPd="20px 0">
          <SearchFilterItemCommon
            brandType={brandType}
            asType={asType}
            storeType={storeType}
            dateType={dateType}
            asStateType={asStateType}
            selectedChips={selectedChips}
            setInitFunc={(filter: any) => setInitFunc(filter)}
          />
        </List>
      </BottomModal>

      {/* <BottomModal
        ref={filterStateModalRef}
        onClick={() => asStateInitBtn()}
        onClick2={() => asStateConfirmBtn()}
        onClick3={() => asStateCloseBtn()}
        modalTitle="검색 필터"
        headerBtn="초기화"
        footerBtn="적용하기"
        dimClickFun={asStateCloseBtn}
      >
        <List pd="0 15px" itemPd="20px 0">
          <SearchFilterItemCommon asStateType={asStateType} selectedChips={asStateSelectedChips} />
        </List>
      </BottomModal> */}

      <BottomModal modalTitle="정렬" ref={sortModalRef}>
        <List pd="0 15px">
          <SearchSortItem sortData={["최신순", "오래된순"]} onClick={(e) => sortBtn(e)} initIdx={sortIdx} parentSortIdxFunc={childrenSortIdxFunc} />
        </List>
      </BottomModal>
    </>
  );
};

const SearchSet = styled.div`
  padding: 20px 15px;
`;

const FilterBtnSet = styled.div`
  overflow: hidden;
  overflow-x: scroll;
  width: 100%;
  padding: 15px;
  border-top: 1px solid ${({ theme }) => theme.color.linePrimary};
  border-bottom: 1px solid ${({ theme }) => theme.color.linePrimary};
  ${({ theme }) => theme.flexBox.flexMixin("row", "flex-start")}
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
  > * {
    flex: 0 0 auto;
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
  > button {
    > svg {
      position: relative;
      top: -1px;
    }
  }
  .only-new {
    > svg {
      top: 2px;
      left: 2px;
    }
  }
`;

export default AsList;
